<template>
    <div id="contendor-principal-documentoDeResultados">
        <div id="contenedor-encabezados-documentoDeResultados" class="container-fluid">
            <!-- <h1>Creación de documentos</h1> -->
            <h1>Documentos de resultados</h1>
            <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
                <!-- <div class="flex-grow-1 pl-3"><h4>Creación de documentos a resultados registrados previamente sin documento</h4></div> -->
                <div class="flex-grow-1 pl-3"><h4 style="color: #ffff;">Creación y modificación de documentos a resultados</h4></div>
            </div>
            <div class="area">
                <div id="seccion-generacion-documento" class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-2">
                        <div class="contenedor-color-negro">
                            <h4>Filtros de búsqueda</h4>
                            <hr style="height:2px;border:none;color:var(--verde-pj-100);background-color:var(--verde-pj-100);" class="mt-0"/>
                            <div class="row">
                                <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 align-self-end">
                                    <C020Notificadores 
                                        id="CNOTVCDRP"
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="cambioTipoNotificador" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="catalogoNotificadores.ID" 
                                        :parametros="catalogoNotificadores.parametros" 
                                        :valorDefinido="catalogoNotificadores.valorDefinido" 
                                        :key="catalogoNotificadores.KEY + catalogoNotificadores.contRender"
                                        :filtrarPorJurisdiccion="true"></C020Notificadores>
                                </div>
                                <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-3">
                                    <div id="filtro-fechas" class="form-inline">
                                        <h6 class="mr-2">Fecha de búsqueda: </h6>
                                        <input  v-model="filtrosDeBusqueda.fechaBusqueda" type="date" class="form-control mr-2" />
                                        <!-- <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltrosBusqueda" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button> -->
                                    </div>
                                </div>
                                <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2 pl-0 pr-3 align-self-end">
                                    <div class="form-inline justify-content-end">
                                        <button type="button" @click="busquedaResultados" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!resultadosTabla.cargandoResultados" id="seccion-acciones" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-3">
                        <div id="titulo-tabla-busqueda">
                            <div class="d-flex justify-content-center">
                                <i class="fas fa-clipboard-list mr-sm-2 texto-ajustable" style="color: black;"></i>
                                <div class="align-content-center">
                                    <h5 class="texto-ajustable" style="color: black;">Listado de cédulas encontradas</h5>
                                </div>
                            </div>
                        </div>
                        <div class="contenedor-color-negro">
                            <div class="form-inline justify-content-end">
                                <div id="inputs-filtro-memoria" class="form-inline pr-0">
                                    <h6 for="f-busqueda" class="mr-sm-2">Buscar:</h6>
                                    <input v-model="filtrosDeBusqueda.valorDeBusqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control flex-grow-1"/>
                                </div>
                            </div>
                            <CTablaGenericaCedulas class="table-responsive mt-4"
                                :idDelInput="resultadosTabla.ID"
                                :encabezadosColumnas="resultadosTabla.ENCABEZADOS_COLUMNAS"
                                :accionesEnTabla="resultadosTabla.ACCIONES"
                                :listaDeCedulas="resultadosTabla.listaFiltrosMemoria"
                                v-on:accionFuncionAgregar="evtMostrarFormulario"
                                :conResponsive="true"
                                v-on:accionesFuncionaActualizarDoc="evtActalizarDocumento"
                                :permitirActualizarDocumentos="true"
                                :ref="resultadosTabla.REF"></CTablaGenericaCedulas>
                        </div>
                    </div>
                    <div v-show="resultadosTabla.cargandoResultados" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-3">
                        <div class="contenedor-cargando" style="height: 300px ;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                <h4 class="mt-4">Cargando Cedulas</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- FORMULARIO GENERACION DE DOCUMENTO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-generacion-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de resultado {{ folioCedulaSeleccionada }}</h5>
                        <button id="btn-cerrar-formulario-generacion-documento" @click="evtCerrarFormulario" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div id="modal-formulario" class="modal-body pl-4 pr-4 pt-2 pb-4">
                        <!-- PASOS -->
                        <div class="contenedor-pasos-formulario">
                            <ul id="barra-progreso-pasos-individual" class="barra-progreso">
                                <li :id="formularioDocumento.pasos.uno.ID" class="">{{ formularioDocumento.pasos.uno.descripcion }}</li>
                                <li :id="formularioDocumento.pasos.dos.ID" class="">{{ formularioDocumento.pasos.dos.descripcion }}</li>
                            </ul>
                        </div>
                        <!-- FIN PASOS -->
                        <div v-show="formularioDocumento.pasoSeleccionado.ID == formularioDocumento.pasos.uno.ID" class="contenedor-color-negro">
                            <h5>Paso 1: Elige una plantilla para el resultado</h5>
                            <hr />
                            <!-- FECHA DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div class="form-group">
                                <h6 class="mr-2">Fecha de constitución de cédula: </h6>
                                <input v-model="formularioDocumento.fechaConstitucionComplemento" type="date" class="form-control" />
                            </div>
                            <!-- HORA DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div class="form-group">
                                <h6 class="mr-2">Hora de constitución cédula (solo numero en letra): </h6>
                                <input v-model="formularioDocumento.horaConstitucion" type="text" class="form-control" />
                            </div>
                            <!-- MINUTO DE CONSTITICION EN DOMICILIO DE LA CEDULA -->
                            <div class="form-group">
                                <h6 class="mr-2">Minutos de constitución cédula (solo numero en letra): </h6>
                                <input v-model="formularioDocumento.minutoConstitucion" type="text" class="form-control" />
                            </div>
                            <div class="form-group">
                                <h6>Complementos a documento del resultado</h6>
                                <textarea v-model="formularioDocumento.complementosDocumentoResultado" rows="3" type="text" class="form-control"/>
                            </div>
                            <C009TiposPlantilla class="p-0 m-0" 
                                v-on:valorParaElPadre="evtCambioPlantilla" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="formularioDocumento.catalogoPlantillas.ID" 
                                :parametros="formularioDocumento.catalogoPlantillas.parametros"
                                :valorDefinido="formularioDocumento.catalogoPlantillas.valorDefinido"
                                :key="formularioDocumento.catalogoPlantillas.KEY + formularioDocumento.catalogoPlantillas.contRender"></C009TiposPlantilla>
                            <PDFDocument v-if="this.campoRequeridoEsValido(formularioDocumento.catalogoPlantillas.plantilla)" class="mt-2"
                                :url="formularioDocumento.catalogoPlantillas.visorPdf.url" 
                                :ArchivoAConvertir="formularioDocumento.catalogoPlantillas.visorPdf.archivo"
                                :height="formularioDocumento.catalogoPlantillas.visorPdf.height"
                                :key="'VDPVCDRP' + formularioDocumento.catalogoPlantillas.visorPdf.contRender" />
                        </div>
                        <div v-show="formularioDocumento.pasoSeleccionado.ID == formularioDocumento.pasos.dos.ID" class="contenedor-color-negro">
                            <h5>Paso 2: Complementar archivo (opcional).</h5>
                            <hr />
                            <div class="form-group mb-2">
                                 <div class="form-group">
                                    <div class="d-flex align-items-center">
                                        <input type="file" id="input-archivoDeResultado" 
                                            :class="(formularioDocumento.documentoResultado.mostrarError && !this.campoRequeridoEsValido(formularioDocumento.documentoResultado.archivo)) ? 'border border-danger form-control mr-2' : 'form-control mr-2'" 
                                            v-on:change="evtActaulizarDocumentoResultado($event)" accept=".DOC, .DOCX, .PDF" /> 
                                        <div><button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Documento</button></div>
                                    </div>
                                </div>
                                <PDFDocument 
                                    :url="formularioDocumento.visorPdf.url" 
                                    :ArchivoAConvertir="formularioDocumento.visorPdf.archivo"
                                    :EsBase64="EsBase64"
                                    :EsBlob = "EsBlob"
                                    :height="formularioDocumento.visorPdf.height"
                                    :key="'RSVDPVCDRP' + formularioDocumento.visorPdf.contRender" />
                            </div>
                        </div>
                        <div v-if="formularioDocumento.pasoSeleccionado != null" class="form-inline justify-content-between mt-3">
                            <div class="w-40">
                                <i v-if="formularioDocumento.mostrarMensajeError" class="mensaje-error-formulario">(*) Debes lenar los campos obligatorios</i>
                            </div>
                            <div>
                                <button v-if="formularioDocumento.pasoSeleccionado.ID != formularioDocumento.pasos.uno.ID" @click="evtSeleccionPasoFormulario(false)" type="button" class="btn btn-primary mr-2"><i class="fas fa-arrow-circle-left"></i>&nbsp;Anterior</button>
                                <button v-if="formularioDocumento.pasoSeleccionado.ID != formularioDocumento.pasos.dos.ID" @click="evtSeleccionPasoFormulario(true)" type="button" class="btn btn-primary">Siguiente&nbsp;<i class="fas fa-arrow-circle-right"></i></button>
                                <button v-if="formularioDocumento.pasoSeleccionado.ID == formularioDocumento.pasos.dos.ID" @click="evtGuardarResultado(true, true)" type="button" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;Guardar</button>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL ACTUALIZACION DE DOCUMENTO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-actualizacion-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Actualización de documento de resultado, {{ folioCedulaSeleccionada }}</h5>
                        <button id="btn-cerrar-formulario-actualizacion-documento" @click="limpiarFormularioDeActualizacion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div id="modal-formulario" class="modal-body pl-4 pr-4 pt-2 pb-4">
                        <div class="contenedor-color-negro">
                            <h6>Nuevo documento para resultado</h6>
                            <div class="form-group">
                                <div class="form-group">
                                    <input type="file" id="input-archivoDeResultado-actualizado" class="form-control" v-on:change="evtObtenerDocumentoActualizado($event)" accept=".DOC, .DOCX, .PDF" /> 
                                </div>
                                <PDFDocument v-if="this.campoRequeridoEsValido(formularioAcualizacion.documento.archivo)"
                                    :url="formularioAcualizacion.visorPdf.url" 
                                    :ArchivoAConvertir="formularioAcualizacion.visorPdf.archivo"
                                    :EsBase64="EsBase64"
                                    :EsBlob = "EsBlob"
                                    :height="formularioAcualizacion.visorPdf.height"
                                    :key="'RSVDPVCDRPACZ' + formularioAcualizacion.visorPdf.contRender" />
                            </div>
                        </div>
                        <div v-if="this.campoRequeridoEsValido(formularioAcualizacion.documento.archivo)" class="form-inline justify-content-end mt-3">
                            <button type="button" @click="abrirModalConfirmacionActualizarDocumento" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;Guardar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL PARA CONFIRMACION DE ACTUALIZACION DE DOCUMENTO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmacion-actualizacion">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group text-center">
                            <h6>Si deseas continuar el documento del archivo se actualizará y eliminará el anterior, ¿Deseas continuar?</h6>
                            <div id="seccion-respaldo" class="mt-2">
                                <i>Se recomienda descargar el documento actual para tener un respaldo (opcional).</i><br>
                                <button type="button" class="btn btn-sm btn-success mt-2" @click="evtDescargarArchivo(formularioDocumento.cedulaSeleccionada.Resultado.ArchivoResultado_Ruta)"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1 acciones-confirmacion-actualizacion"><button type="button" class="btn btn-block btn-primary" @click="evtCerrarModalConfirmacion"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                            <div class="col-6 pr-1 pl-1 acciones-confirmacion-actualizacion"><button type="button" class="btn btn-block btn-primary" @click="iniciarProcesoActualizacionDocumento"><i class="fas fa-save"></i>&nbsp;&nbsp;Continuar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import moment from 'moment'
import catalogos from '@/../static/js/catalogos'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import router from '@/router/index'

export default {
    components: {
         CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
         C020Notificadores: catalogos.SINOJ.C020Notificadores,
         PDFDocument,
         C009TiposPlantilla: catalogos.SINOJ.C009TiposPlantilla
    },
    data() {
        return {
            EsBase64:{
                esBase64:false,
                archivoBase64:null
            },
            EsBlob:{
             esBlob:false,
             blob:null},
            enumeraciones,
            resultadosTabla: {
                ID: 'TablaResultadosVCDRP',
                REF: 'REFTablaResultadosVCDRP',
                ENCABEZADOS_COLUMNAS:  ['Folio','Consecutivo','Juzgado','Urgente','Domicilio','Persona a notificar','Tipo de cédula',''],
                ACCIONES: { motrarAcciones: true,check: false, eliminar: false, constituir: false, agregar: true },
                listaObjBD: [],
                listaObjVista: [],
                listaFiltrosMemoria: [],
                cargandoResultados: false
            },
            formularioDocumento: {
                resultado: null,
                pasos: {
                    uno: { ID: 'paso-uno', anterior: null, siguiente: 'paso-dos', descripcion: 'Paso 1' },
                    dos: { ID: 'paso-dos', anterior: 'paso-uno', siguiente: null, descripcion: 'Paso 2' }
                },
                pasoSeleccionado: null,
                catalogoPlantillas: {
                    ID: 'CTiposPlantillasVCDRP',
                    parametros: { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.razon.llave, ConInactivos: false, EsPrueba: false },
                    valorDefinido: -1,
                    KEY: 'KCTiposPlantillasVCDRP',
                    REF: 'RCTiposPlantillasVCDRP',
                    contRender: 0,
                    plantilla: null,
                    visorPdf: {
                        url: null,
                        height: '290px',
                        archivo: null,
                        contRender: 0
                    },
                    horaConstitucion: null,
                    minutoConstitucion: null
                },
                mostrarMensajeError: false,
                documentoResultado: {
                    archivo: null,
                    mostrarError: false,
                    realizoCambios: false
                },
                visorPdf: {
                    url: null,
                    height: '400px',
                    archivo: null,
                    contRender: 0
                },
                cedulaSeleccionada: null,
                complementosDocumentoResultado: null,
                fechaConstitucionComplemento: moment().format('YYYY-MM-DD')
            },
            catalogoNotificadores: {
                ID: 'CNotificadoresVCDRP',
                parametros: {NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false},
                valorDefinido: -1,
                KEY: 'KCNotificadoresVCDRP',
                contRender: 0,
                notificadorObj: null
            },
            filtrosDeBusqueda: {
                fechaBusqueda: moment().format('YYYY-MM-DD'),
                valorDeBusqueda: null
            },
            esNotificador: false,
            cargoAreaDeUsuario: false,
            usuarioEsDeJuzgadoMixto: false,
            formularioAcualizacion: {
                visorPdf: {
                    url: null,
                    height: '400px',
                    archivo: null,
                    contRender: 0
                },
                documento: {
                    archivo: null
                }
            }
        }
    },
    methods: {
        evtCerrarModalConfirmacion: function() {
            $("#modal-confirmacion-actualizacion").modal('hide');
            $("#formulario-actualizacion-documento").modal('show');
            this.formularioAcualizacion.visorPdf.contRender ++;
        },
        evtDescargarArchivo: function(rutaArchivo) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
        },
        abrirModalConfirmacionActualizarDocumento: function() {
            $("#formulario-actualizacion-documento").modal('hide');
            $("#modal-confirmacion-actualizacion").modal('show');
        },
        evtActalizarDocumento: function(evento, cedula) { debugger
            this.formularioDocumento.cedulaSeleccionada = this.resultadosTabla.listaObjBD.find(c => c.CedulaId == cedula.Folio);
            $("#formulario-actualizacion-documento").modal('show');
        },
        iniciarProcesoActualizacionDocumento: async function() {
            let peticionAPi = await Promise.resolve(this.crearPeticionActualizacionDocumento());
            $("#modal-confirmacion-actualizacion").modal('hide');
            await Promise.resolve(this.actualizarDocumentoBD({ peticion: peticionAPi, conActualizacionDeCedulas: true }));
            this.busquedaResultados();
        },
        actualizarDocumentoBD: async function({ peticion, conActualizacionDeCedulas = false }) { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_ACTUALIZAR = api.SINOJ.sistema.notificaciones.resultado.ActualizarDocumento;
            let urlApi = SERVIDOR + METODO_API_ACTUALIZAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            const PETICION_ACTUALIZACION = await axios.post(urlApi, peticion, headerPeticion);
            const DATOS_PETICION = await PETICION_ACTUALIZACION.data;
            let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(false);
                console.log(Error);
                comun.mensajeDeAlerta(mensajeError, null, null);
                $("#formulario-actualizacion-documento").modal('show');
            } 
            else {
                this.limpiarFormularioDeActualizacion();
                comun.mensajeDeAlerta(Satisfactorio, null, null);
            }

            if(conActualizacionDeCedulas)
                comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        },
        crearPeticionActualizacionDocumento: async function() {
            let peticion = new FormData();
            const RESULTADO_OBJ = this.formularioDocumento.cedulaSeleccionada.Resultado;
            peticion.append('Resultado',JSON.stringify(RESULTADO_OBJ));
            peticion.append('DocumentoActualizado',this.formularioAcualizacion.documento.archivo);
            peticion.append('EsPrueba',false);
            return peticion;
        },
        evtObtenerDocumentoActualizado: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const ARCHIVO = evento.target.files[0];
                    this.formularioAcualizacion.documento.archivo = ARCHIVO;
                    this.formularioAcualizacion.visorPdf.url = null;
                    this.formularioAcualizacion.visorPdf.archivo = this.formularioAcualizacion.documento.archivo;
                    this.formularioAcualizacion.visorPdf.contRender ++;
                }
                else {
                    this.formularioAcualizacion.documento.archivo = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        limpiarFormularioDeActualizacion: function() {
            this.formularioDocumento.cedulaSeleccionada = null;
            this.formularioAcualizacion.documento.archivo = null;
             $("#input-archivoDeResultado-actualizado").val('');
        },
        evtCerrarFormulario: function() { debugger
            const PASOS_REALIZADOS = Object.values(this.formularioDocumento.pasos).filter(p => $("#" + p.ID).hasClass("active")).length;
            const TODOS_LOS_PASOS_TERMINADOS = (PASOS_REALIZADOS == Object.values(this.formularioDocumento.pasos).length);
            if(TODOS_LOS_PASOS_TERMINADOS || this.campoRequeridoEsValido(this.formularioDocumento.resultado))
                this.confirmacionResulatadoCorrecto();
            else {
                $("#formulario-generacion-documento").modal('hide');
            }
        },
        confirmacionResulatadoCorrecto: function() {
            let mensaje =  'Ya has terminado todos los pasos en el formulario, si cierras el formulario se guardara el documento del resultado con los datos capturados en los pasos del formulario';
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:`${ mensaje }.<br>¿Deseas guardar el resultado?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        const CON_MENSAJE_RESULTADO_CREADO = true;
                        this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                    }
                    else {
                        $("#formulario-generacion-documento").modal('show');
                    }
                }
            });
        },
        evtDescargarDocumento: function() {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.formularioDocumento.resultado.ArchivoResultado_Ruta}`
            a.click();
        },
        evtActaulizarDocumentoResultado: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.formularioDocumento.documentoResultado.mostrarMensajeError = false;
                    this.formularioDocumento.documentoResultado.archivo = evento.target.files[0];
                    this.formularioDocumento.visorPdf.url = null;
                    this.formularioDocumento.visorPdf.archivo = this.formularioDocumento.documentoResultado.archivo;
                    this.formularioDocumento.visorPdf.contRender ++;
                }
                else {
                    this.formularioDocumento.documentoResultado.mostrarMensajeError = true;
                    this.formularioDocumento.documentoResultado.archivo = null;
                }
                this.formularioDocumento.documentoResultado.realizoCambios = true;
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtSeleccionPasoFormulario: function(siguiente) { debugger
            switch(this.formularioDocumento.pasoSeleccionado.ID) {
                case 'paso-uno':
                    if(siguiente)
                        this.evtGuardarResultado(false, false);
                    else
                        this.identificarSeleccionDePaso(siguiente, this.formularioDocumento.pasos.uno);
                    break;
                case 'paso-dos':
                     if(siguiente)
                        this.identificarSeleccionDePaso(siguiente, this.formularioDocumento.pasos.dos);
                     else
                        this.existeDocumentoActualizado(siguiente);
                    break;
            }
            this.formularioDocumento.catalogoPlantillas.visorPdf.contRender ++;
        },
        limpiarFormulario: function(conMensajeResultadoCreado) {
            this.formularioDocumento.resultado = null;
            $("#formulario-generacion-documento").modal('hide');
            this.formularioDocumento.mostrarMensajeError = false;
            this.limpiarPasoDosPlantillas(this.formularioDocumento);
            this.limpiarDocumentoActualizadoDeArchivo(this.formularioDocumento);
            this.limpiarVisualizadorDeResultado(this.formularioDocumento);
            if(conMensajeResultadoCreado) {
                comun.mensajeDeAlerta(`El resultado se creo y se guardo de manera correcta.`);
            }
            //this.removerCedulasConResultadoListasDeCedulas();
            this.limpiarPasos(this.formularioDocumento);
        },
        removerCedulasConResultadoListasDeCedulas: function() {
            this.resultadosTabla.listaObjBD = this.resultadosTabla.listaObjBD.filter(c => c.CedulaId != this.formularioDocumento.cedulaSeleccionada.CedulaId);
            this.resultadosTabla.listaObjVista = this.resultadosTabla.listaObjVista.filter(c => c.Folio != this.formularioDocumento.cedulaSeleccionada.CedulaId);
            this.resultadosTabla.listaFiltrosMemoria = this.resultadosTabla.listaObjVista;
        },
        limpiarVisualizadorDeResultado: function(formulario) {
            formulario.visorPdf.url = null;
            formulario.visorPdf.archivo = null;
            formulario.visorPdf.contRender ++;
        },
        limpiarDocumentoActualizadoDeArchivo: function(formulario) {
            formulario.documentoResultado.archivo = null;
            formulario.documentoResultado.mostrarError = false;
            formulario.documentoResultado.realizoCambios = false;
            $("#input-archivoDeResultado").val('');
        }, 
        limpiarPasoDosPlantillas: function(formulario) {
            formulario.catalogoPlantillas.parametros = { TipoPlantillaId: null, Nombre: null, TipoCedulaId: null, TipoResultadoId: null, TipoRazonId: null, FechaInicial: null, FechaFinal: null, PlantillasDe: enumeraciones.sinoj.requierenPlantilla.razon.llave, ConInactivos: false, EsPrueba: false };
            formulario.catalogoPlantillas.plantilla = null;
            formulario.catalogoPlantillas.contRender ++;
            formulario.catalogoPlantillas.visorPdf.url = null;
            formulario.catalogoPlantillas.archivo = null;
            formulario.catalogoPlantillas.visorPdf.contRender ++;
            this.formularioDocumento.complementosDocumentoResultado = null;
            this.formularioDocumento.horaConstitucion = null;
            this.formularioDocumento.minutoConstitucion = null;
        },
        limpiarPasos: function(formulario) {
            formulario.pasoSeleccionado = formulario.pasos.uno;
            $("#" + formulario.pasoSeleccionado.ID).addClass('active');
            Object.values(formulario.pasos).forEach(p => {
                $("#" + p.ID).removeClass('active');
            });
        },
        evtGuardarResultado: async function(cerrarFormulario, esPasoFinal) {
           if(this.pasoDosEleccionDePlantilla()) {
                this.formularioDocumento.mostrarErroresPasoUno = false;
                let peticionAPi = await Promise.resolve(this.crearPeticionDeResultado(this.formularioDocumento));
                // se valida si se sucio documento complemnetado para actualizar resultado en base de datos (caso else)
                if(!this.formularioDocumento.documentoResultado.realizoCambios && esPasoFinal) {
                    const CON_MENSAJE_RESULTADO_CREADO = true;
                    this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                }
                else
                    this.guardarResultadoBD(peticionAPi, cerrarFormulario);
           }
        },
        crearPeticionDeResultado: async function(formulario) {
            let peticion = new FormData();
            let resultados = [];
            let resultadoObj = null;
            if(formulario.resultado != null)
                resultados = [formulario.resultado]
            else {
                resultadoObj = formulario.cedulaSeleccionada.Resultado;
                resultadoObj.Cedula = { CedulaId: formulario.cedulaSeleccionada.CedulaId };
                resultados = [resultadoObj] 
            }
            let plantilla = JSON.stringify(formulario.catalogoPlantillas.plantilla);
            peticion.append('Plantilla',plantilla);
            peticion.append('Resultados',JSON.stringify(resultados));
            peticion.append('EsPrueba',false);
            peticion.append('ComplementosDePlantilla',JSON.stringify(this.construirComplementosDePlantilla()));
            peticion.append('DocumentoComplementado',this.campoRequeridoEsValido(formulario.documentoResultado.archivo) ? formulario.documentoResultado.archivo : '');
           /*  console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            return peticion;
        },
        construirComplementosDePlantilla: function() {
            /* let complemento = '';
            if(this.campoRequeridoEsValido(this.formularioDocumento.fechaConstitucionComplemento))
                complemento += (' ' + this.formularioDocumento.fechaConstitucionComplemento + ' - ');
            complemento += this.formularioDocumento.complementosDocumentoResultado;
            return complemento; */
            let complementos = {};
            //const DIA_CONSTITUCION = moment(this.formularioResultadoIndividual.fechaConstitucionComplemento.date).day();getDay()
            const DIA_CONSTITUCION = moment(this.formularioDocumento.fechaConstitucionComplemento).format('D');
            const MES_CONSTITUCION_NUMERICO = moment(this.formularioDocumento.fechaConstitucionComplemento).month();
            const MES_CONSTITUCION = moment().month(MES_CONSTITUCION_NUMERICO).format("MMMM");
            const HORA_CONSTITUCION = moment().hour();
            const MINUTO_CONSTITUCION = moment().minutes();
            complementos.DIA_RESULTADO = DIA_CONSTITUCION;
            complementos.MES_RESULTADO = MES_CONSTITUCION;
            complementos.HORA_RESULTADO = (this.campoRequeridoEsValido(this.formularioDocumento.horaConstitucion)) ? this.formularioDocumento.horaConstitucion.toUpperCase() : '_______________';
            complementos.MINUTOS_RESULTADO = (this.campoRequeridoEsValido(this.formularioDocumento.minutoConstitucion)) ? this.formularioDocumento.minutoConstitucion.toUpperCase() : '_______________';;
            complementos.COMPLEMENTOS = this.formularioDocumento.complementosDocumentoResultado;
            return complementos;
        },
        guardarResultadoBD: function(peticionAPI, cerrarFormulario) {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.notificaciones.resultado.GuardarResultadoDeCedula;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            $("#formulario-generacion-documento").modal('hide'); 
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const RESULTADO = respuesta.data.Resultados[0];
                            // valores para identificar resultado en actualizacion
                            this.formularioDocumento.resultado = RESULTADO;
                            this.formularioDocumento.resultado.Cedula = { CedulaId: RESULTADO.ResultadoId };
                            console.log('RESULTADO::BD::',this.formularioDocumento.resultado);
                            //this.formularioResultadoIndividual.resultadoCedula.rutaDeDocumento = RESULTADO.ArchivoResultado_Ruta;

                            this.formularioDocumento.visorPdf.archivo = null;
                            this.formularioDocumento.visorPdf.url = this.formularioDocumento.resultado.ArchivoResultado_Ruta;
                            this.formularioDocumento.visorPdf.contRender ++;
                            // se marca como terminado y seleccionado el paso opcional final 
                            this.identificarSeleccionDePaso(true, this.formularioDocumento.pasos.uno);
                            // si genera documento con plantilla se habilita la posibilidad de agregar complemento, si no, termina el proceso de creacion
                            $("#" + this.formularioDocumento.pasos.dos.ID).addClass('active');
                            this.limpiarDocumentoActualizadoDeArchivo(this.formularioDocumento);
                            if(!cerrarFormulario)
                                $("#formulario-generacion-documento").modal('show');
                            else {
                                const CON_MENSAJE_RESULTADO_CREADO = true;
                                this.limpiarFormulario(CON_MENSAJE_RESULTADO_CREADO);
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        this.busquedaResultados();
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                         $("#formulario-generacion-documento").modal('show');
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        existeDocumentoActualizado: function(siguiente) { 
            if(this.formularioDocumento.documentoResultado.realizoCambios) {
                $("#formulario-generacion-documento").modal('hide');
                this.informarPerdidaDeCambiosEnDocumento();
            }
            else {
                this.identificarSeleccionDePaso(siguiente, this.formularioDocumento.pasos.dos);
            }
        },
        informarPerdidaDeCambiosEnDocumento: function(siguiente) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:`Se detecto uso del subidor de complementos, si retrocedes a unos de los pasos anteriores se perderan los cambios realizados al documento.<br>¿Deseas continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.limpiarDocumentoActualizadoDeArchivo();
                        this.identificarSeleccionDePaso(siguiente, this.formularioDocumento.pasos.dos);
                        $("#formulario-generacion-documento").modal('show');
                    }
                    else {
                        $("#formulario-generacion-documento").modal('show');
                    }
                }
            });
        },
        limpiarDocumentoActualizadoDeArchivo: function() {
            this.formularioDocumento.documentoResultado.archivo = null;
            this.formularioDocumento.documentoResultado.mostrarError = false;
            this.formularioDocumento.documentoResultado.realizoCambios = false;
            $("#input-archivoDeResultado").val('');
        }, 
        identificarSeleccionDePaso: function(siguiente, pasoSeleccionado) { debugger
            let accionRealizada = null;
            if(siguiente) {
                if(this.puedeAvanzarAOtroPaso()) {
                    $("#" + pasoSeleccionado.ID).addClass('active');
                        accionRealizada = (pasoSeleccionado.siguiente != null) ?
                            Object.values(this.formularioDocumento.pasos).find(p => p.ID == pasoSeleccionado.siguiente) : pasoSeleccionado;
                }
                else {
                    accionRealizada = this.formularioDocumento.pasoSeleccionado;
                }
            }
            else {
                accionRealizada = (pasoSeleccionado.anterior != null) ?
                    Object.values(this.formularioDocumento.pasos).find(p => p.ID == pasoSeleccionado.anterior) : pasoSeleccionado;
                this.formularioDocumento.mostrarMensajeError = false;
            }
            this.formularioDocumento.pasoSeleccionado = accionRealizada;
        },
        puedeAvanzarAOtroPaso: function() { debugger
            let permitirAvance = true;
            switch(this.formularioDocumento.pasoSeleccionado.ID) {
                case 'paso-uno':
                    permitirAvance = this.pasoDosEleccionDePlantilla();
                    break;
            }
            return permitirAvance;
        },
        pasoDosEleccionDePlantilla: function() { debugger
            let camposValidos = this.campoRequeridoEsValido(this.formularioDocumento.catalogoPlantillas.plantilla);
            this.formularioDocumento.mostrarMensajeError = !camposValidos;
            return camposValidos;
        },
        evtCambioPlantilla(evento,tipoPlantillaObj) { 
            this.formularioDocumento.catalogoPlantillas.plantilla = tipoPlantillaObj;
            if(this.campoRequeridoEsValido(this.formularioDocumento.catalogoPlantillas.plantilla = tipoPlantillaObj)) {
                this.formularioDocumento.catalogoPlantillas.visorPdf.url = this.formularioDocumento.catalogoPlantillas.plantilla.Ruta;
                this.formularioDocumento.catalogoPlantillas.visorPdf.contRender ++;
                this.formularioDocumento.mostrarMensajeError = false;
            }
        },
        cambioTipoNotificador: function(evento, notificador) {
            this.catalogoNotificadores.notificadorObj = notificador;
        },
        evtMostrarFormulario: async function(evento) {
            if(this.formularioDocumento.pasoSeleccionado == null)
                this.formularioDocumento.pasoSeleccionado = this.formularioDocumento.pasos.uno;
            this.formularioDocumento.cedulaSeleccionada = await Promise.resolve(this.obtenerCedulaSeleccionado(evento));
            this.obtenerUltimaFechaDeSalida({ cedula: this.formularioDocumento.cedulaSeleccionada });
            $("#formulario-generacion-documento").modal('show');
        },
        obtenerUltimaFechaDeSalida: function({ cedula }) { debugger 
            this.formularioDocumento.fechaConstitucionComplemento = moment().format('YYYY-MM-DD');
            if(this.campoRequeridoEsValido(cedula) && this.campoRequeridoEsValido(cedula.Salidas) && cedula.Salidas.length > 0) {
                const SALIDAS_ORDENAMIENTO = cedula.Salidas.map(s => { return s.SalidaId });
                const ID_ULTIMA_SALIDA = Math.max.apply(0, SALIDAS_ORDENAMIENTO);
                const ULTIMA_SALIDA_OBJ = cedula.Salidas.find(s => s.SalidaId == ID_ULTIMA_SALIDA);
                this.formularioDocumento.fechaConstitucionComplemento = moment(ULTIMA_SALIDA_OBJ.FechaSalida).format('YYYY-MM-DD');
            }
        },
        obtenerCedulaSeleccionado: async function(evento) {
            let cedula = null;
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.resultadosTabla.listaObjBD.filter(cDB => cDB.CedulaId == ID_CEDULA).forEach(c => {
                cedula = c;
            });
            return cedula;
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtResetearFiltrosBusqueda: function() {
            if(!this.esNotificador) {
               this.catalogoNotificadores.valorDefinido = -1;
                this.catalogoNotificadores.notificadorObj = null;
                this.catalogoNotificadores.contRender ++;
                this.catalogoNotificadores.parametros = {NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false}; 
            }
            if(this.usuarioEsDeJuzgadoMixto) {
                this.catalogoNotificadores.notificadorObj = null;
            }
            this.filtrosDeBusqueda.fechaBusqueda = moment().format('YYYY-MM-DD');
            this.filtrosDeBusqueda.valorDeBusqueda = null;
        },
        filtrarCedulasTabla: function(e) {
            this.resultadosTabla.listaFiltrosMemoria = this.resultadosTabla.listaObjVista
            .filter(c => {
                return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.filtrosDeBusqueda.valorDeBusqueda));
            });
            console.log()
        },
        predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
            if(this.campoRequeridoEsValido(compararCon)) {
                if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
                    return true;
                else
                    return false;
            }
            else
                return true;
        },
        busquedaResultados: function() {
           const SERVIDOR = api.conexion;
           const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.resultado.ObtenerResultadosSinDocumento;
           let urlApi = SERVIDOR + METODO_API_OBTENER;
           let peticionAPI = {
                TipoNotificadorId: (this.campoRequeridoEsValido(this.catalogoNotificadores.notificadorObj) && this.campoRequeridoEsValido(this.catalogoNotificadores.notificadorObj.NotificadorId)) ? this.catalogoNotificadores.notificadorObj.NotificadorId : null,
                FechaResultado: (this.campoRequeridoEsValido(this.filtrosDeBusqueda.fechaBusqueda)) ? this.filtrosDeBusqueda.fechaBusqueda : null
            };
            peticionAPI.esPrueba = false;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.resultadosTabla.cargandoResultados = true;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const { Resultados } = respuesta.data;
                            this.resultadosTabla.listaObjBD = (this.campoRequeridoEsValido(Resultados)) ? Resultados : [];
                            this.resultadosTabla.listaObjVista = this.darFormatoCedulasTabla(Resultados);
                            this.resultadosTabla.listaFiltrosMemoria = this.resultadosTabla.listaObjVista;
                            this.$nextTick(() => {
                                $("#inputs-filtro-memoria input").on("change paste keyup", (e) => {
                                    if(this.resultadosTabla.listaObjVista.length > 0) {
                                        this.filtrarCedulasTabla(e);
                                    }
                                });
                            });
                        }
                        this.resultadosTabla.cargandoResultados = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.resultadosTabla.cargandoResultados = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        darFormatoCedulasTabla: function(cedulas) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(c => {
                let cedula = this.cedulaAObjetoTabla(c);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(cedula) { debugger
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo'; 
            cedulaObjTabla.Juzgado = 'Sin juzgado';
            if(this.campoRequeridoEsValido(cedula.Expediente)) { 
                cedulaObjTabla.Juzgado = (cedula.Expediente.Juzgado != null ) ? cedula.Expediente.Juzgado.Nombre : 'Sin juzgado';
                cedulaObjTabla.Consecutivo = cedula.Expediente.NumeroDeDocumento; 
            }
            cedulaObjTabla.urgente = (cedula.Urgente) ? 'SI' : 'NO';
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(cedula.PersonasANotificar)) {
                if(cedula.PersonasANotificar[0].Domicilios != null && cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                }
            }
            cedulaObjTabla.TipoCedula = (this.campoRequeridoEsValido(cedula.TipoCedula.Nombre)) ? cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula';
            cedulaObjTabla.rutaDeDocumento = (this.campoRequeridoEsValido(cedula.Resultado)) ? cedula.Resultado.ArchivoResultado_Ruta : null;
            return cedulaObjTabla;
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
        },
        esJuzgadoMixto: function(area) { 
            const { AreaId } = area;
            const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
            if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                this.usuarioEsDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == AreaId);
            }
        },
        asignarValoresUsuarioNotificador: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.resultado.ObtenerDatosDeNotificador;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { esPrueba: false };
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoCedulas = true;
            const PETICION_NOTIFICADOR = await axios.post(urlApi, peticionAPI, headerPeticion);
            const DATOS_PETICION = await PETICION_NOTIFICADOR.data;
            let { SiHayError, Error, Notificador } = DATOS_PETICION;
            if (SiHayError) {
                let mensajeError = Error.Mensaje;
                comun.SeEstaCargandoInformacion(true);
                console.log(Error);
                this.esNotificador = false;
                /* router.push({ name: "SINOJ"});
                comun.mensajeDeAlerta(mensajeError, null, null); */
            } 
            else {
                this.esNotificador = true;
                if(this.campoRequeridoEsValido(Notificador)) {
                    this.catalogoNotificadores.notificadorObj = Notificador;
                    this.catalogoNotificadores.valorDefinido = Notificador.NotificadorId;
                    this.catalogoNotificadores.contRender ++;
                    this.$nextTick(() => {
                        $("#CNOTVCDRP").addClass('catalogoInformativo');
                    });
                }
                else {
                    this.$nextTick(() => {
                        $("#CNOTVCDRP").removeClass('catalogoInformativo');
                    });
                }
            }
          }
          catch(excepcion) {
              comun.SeEstaCargandoInformacion(false);
              console.log(excepcion);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        }
    },
    async mounted() {
        $(window).on('resize', () => {
            this.formularioDocumento.catalogoPlantillas.visorPdf.contRender ++;
        });

        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);

            if(!this.usuarioEsDeJuzgadoMixto)
                 await Promise.resolve(this.asignarValoresUsuarioNotificador());
            this.busquedaResultados();
        }
    },
    created() {
        if(this.formularioDocumento.pasoSeleccionado == null)
                this.formularioDocumento.pasoSeleccionado = this.formularioDocumento.pasos.uno;
    },
    computed: {
        folioCedulaSeleccionada() {
            return (this.campoRequeridoEsValido(this.formularioDocumento.cedulaSeleccionada)) ? 
                `cédula [ #${ this.formularioDocumento.cedulaSeleccionada.CedulaId } ]` : '';
        }
    },
    watch: {
        '$store.state.Login_Usuario.Area': async function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                this.esJuzgadoMixto(this.$store.state.Login_Usuario.Area);
                
                if(!this.usuarioEsDeJuzgadoMixto)
                    await Promise.resolve(this.asignarValoresUsuarioNotificador());
                this.busquedaResultados();
            }
        }
    },
}
</script>
<style scoped>
#inputs-filtro-memoria {
    width: 50vmin;
}

.acciones-confirmacion-actualizacion .btn-block{
    height: 45px;
    background-color: black;
}

#formulario-generacion-documento .modal-lg {
    max-width: 60% !important;
}

#formulario-generacion-documento .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-confirmacion-actualizacion .modal-lg {
    max-width: 25% !important;
}

#modal-confirmacion-actualizacion .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#formulario-actualizacion-documento .modal-lg {
    max-width: 60% !important;
}

#formulario-actualizacion-documento .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#encabezado-contenedor-contenido {
  background-color: var(--verde-pj);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

.contenedor-color-negro {
    padding: 1.5em;
    /* background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616; */
}

#titulo-tabla-busqueda {
    background-color:var(--gris-pj);
    padding-top: 13px;
    padding-bottom: 8px;
    margin-top: 1vw;
}

.contenedor-cargando {
    /* background-color: rgb(36, 34, 34); */
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.texto-ajustable {
    font-size: 1.5vw;
}

#filtro-fechas .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtro-fechas .btn-sm:hover, #filtro-fechas .btn-sm:focus {
  background-color: black;
}

#modal-formulario .btn-sm {
    cursor: pointer;
    background-color: rgb(27, 25, 25);
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

/* BARRA PASOS */
.contenedor-pasos-formulario {
    width: 100%;
    height: 70px;
    text-align: center;
}

.barra-progreso {
    counter-reset: step;
    position: relative;
    left: 20%;
    z-index: 0;
}

.barra-progreso li {
    list-style-type: none;
    width: 25%;
    float: left;
    font-size: 12px;
    font-weight: bold;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    color: white;
}

.barra-progreso li:before {
    width: 30px;
    height: 30px;
    content: counter(step);
    counter-increment: step;
    line-height: 30px;
    border: 2px solid black;
    display: block;
    text-align: center;
    margin: 0 auto 4px auto;
    border-radius: 50%;
    background-color: #525357;
    cursor: pointer;
}

.barra-progreso li:after {
    width: 100%;
    height: 2px;
    content: '';
    position: absolute;
    background-color: #7d7d7d;
    top: 15px;
    left: -50%;
    z-index: -1;
}

.barra-progreso li:first-child:after {
    content: none;
}

.barra-progreso li.active {
    color: white;
}

.barra-progreso li.active:before {
    border-color: black;
    font-family: "Font Awesome 5 Free";
    content: "\f00c";
    background-color: black;
}

.barra-progreso li.active+li:after {
    background-color: black;
}

#contendor-principal-documentoDeResultados .area {
    background-color: var(--gris-pj-100);
    box-shadow: none;
}

#contendor-principal-documentoDeResultados .form-control {
    background-color: white !important;
    color: black !important;
}

#contendor-principal-documentoDeResultados h6 {
    color: black;
}

#contendor-principal-documentoDeResultados .btn-primary {
    background-color: var(--verde-pj-100);
}

#contendor-principal-documentoDeResultados .modal-header {
    background-color: var(--verde-pj);
}

#contendor-principal-documentoDeResultados .modal-body {
    background-color: var(--gris-pj-100);
}

.contenedor-color-negro h5 {
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/CreacionDeDocumentos/CCreacionDeDocumentoResultadosPrevios.vue